import { render } from "./TabEquipos.vue?vue&type=template&id=73de00bd"
import script from "./TabEquipos.vue?vue&type=script&lang=js"
export * from "./TabEquipos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__